import React from 'react'

function PulseIcon({ color = 'currentColor', size = 20, ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_8246_3958)">
                <path d="M14.6668 8.00065H13.0135C12.7221 8.00003 12.4386 8.09485 12.2062 8.27063C11.9739 8.4464 11.8055 8.69345 11.7268 8.97398L10.1602 14.5473C10.1501 14.5819 10.129 14.6123 10.1002 14.634C10.0713 14.6556 10.0362 14.6673 10.0002 14.6673C9.9641 14.6673 9.92901 14.6556 9.90016 14.634C9.87131 14.6123 9.85026 14.5819 9.84016 14.5473L6.16016 1.45398C6.15007 1.41937 6.12901 1.38895 6.10016 1.36732C6.07131 1.34568 6.03622 1.33398 6.00016 1.33398C5.9641 1.33398 5.92901 1.34568 5.90016 1.36732C5.87131 1.38895 5.85026 1.41937 5.84016 1.45398L4.2735 7.02732C4.19514 7.30675 4.02775 7.55299 3.79674 7.72866C3.56573 7.90432 3.28371 7.99982 2.9935 8.00065H1.3335" stroke={color} stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_8246_3958">
                    <rect width={size} height={size} fill={color} />
                </clipPath>
            </defs>
        </svg>
    )
}

export default PulseIcon
